export default {
  UPDATE_CAMBIO_STATE(state, payload) {
    state.cambioItens = payload;
  },
  UPDATE_SELECTED_CAMBIO(state, payload) {
    state.selectedCambio = payload;
  },
  UPDATE_COLUNAS_DISPONIVEIS(state, payload) {
    state.colunasDisponiveis = payload;
  },
  SET_COLUNAS_DINAMICAS(state, payload) {
    state.colunasDinamicasCambio = payload;
  },
};
